export default __webpack_public_path__ + "static/media/logo.bb825e8c.png";